import Vue from 'vue'
import Router, { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(Router)

/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if true, this route will not show in the sidebar (default is false)
  }
*/
export const constantRoutes: RouteConfig[] = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    meta: { hidden: true, title: '用户登录' }
  },
  {
    path: '/404',
    component: () => import('@/views/404.vue'),
    meta: { hidden: true }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: {
          title: '主页',
          icon: 'dashboard'
        }
      }
    ]
  }
]
export const asyncRouterMap: RouteConfig[] = [
  {
    path: '/sys',
    component: Layout,
    redirect: '/dashboard',
    name: 'Sys',
    meta: {
      title: '基础信息',
      icon: 'example',
      roles: ['Station Management', 'Station Employee Management', 'Company Management', 'Company Driver Management']
    },
    children: [
      {
        path: 'station',
        name: 'Station Management',
        component: () => import('@/views/station/index.vue'),
        meta: { title: '气站管理', icon: 'tree', roles: ['Station Management'] }
      },
      {
        path: 'station_employee',
        name: 'Station Employee',
        component: () => import('@/views/station/employee/index.vue'),
        meta: { title: '气站雇员', icon: 'tree', roles: ['Station Employee Management'] }
      },
      {
        path: 'company',
        name: 'Company Management',
        component: () => import('@/views/company/index.vue'),
        meta: { title: '车队管理', icon: 'tree', roles: ['Company Management'] }
      },
      {
        path: 'company_recharge',
        name: 'Company Recharge',
        component: () => import('@/views/company/recharge/index.vue'),
        meta: { title: '车队充值', icon: 'tree', roles: ['Company Recharge'] }
      },
      {
        path: 'company_recharge_audit',
        name: 'Company Recharge Audit',
        component: () => import('@/views/company/recharge/audit.vue'),
        meta: { title: '充值审核', icon: 'tree', roles: ['Company Recharge Audit'] }
      },
      {
        path: 'company_driver',
        name: 'Company Driver',
        component: () => import('@/views/driver/index.vue'),
        meta: { title: '车队司机', icon: 'tree', roles: ['Company Driver Management'] }
      },
      {
        path: 'personal_recharge',
        name: 'Personal Recharge',
        component: () => import('@/views/driver/recharge/index.vue'),
        meta: { title: '个人充值', icon: 'tree', roles: ['Personal Recharge'] }
      },
      {
        path: 'personal_recharge_audit',
        name: 'Personal Recharge Audit',
        component: () => import('@/views/driver/recharge/audit.vue'),
        meta: { title: '个人充值审核', icon: 'tree', roles: ['Personal Recharge Audit'] }
      },
      {
        path: 'card',
        name: 'Card',
        component: () => import('@/views/card/index.vue'),
        meta: { title: '卡片管理', icon: 'tree', roles: ['Card Management'] }
      },
      {
        path: 'replacement',
        name: 'Replacement',
        component: () => import('@/views/card/replacement.vue'),
        meta: { title: '卡片补发', icon: 'tree', roles: ['Card Management'] }
      }
    ]
  },
  {
    path: '/dynamic',
    component: Layout,
    redirect: '/dynamic/company',
    name: 'Dynamic',
    meta: { title: '动态查询', icon: 'tree', roles: ['Company Dynamic Search'] },
    children: [
      {
        path: 'company',
        name: 'Company',
        component: () => import('@/views/company/dynamic/index.vue'),
        meta: { title: '车队动态', icon: 'tree', roles: ['Company Dynamic Search'] }
      },
      {
        path: 'driver',
        name: 'Driver',
        component: () => import('@/views/driver/dynamic/index.vue'),
        meta: { title: '司机动态', icon: 'tree', roles: ['Driver Dynamic Search'] }
      },
      {
        path: 'station',
        name: 'Station',
        component: () => import('@/views/station/dynamic/index.vue'),
        meta: { title: '气站动态', icon: 'tree', roles: ['Station Dynamic Search'] }
      },
      {
        path: 'card_dynamic',
        name: 'Card Dynamic',
        component: () => import('@/views/card/dynamic/index.vue'),
        meta: { title: '卡片动态', icon: 'tree', roles: ['Card Dynamic Search'] }
      }
    ]
  },
  {
    path: '/acount',
    component: Layout,
    redirect: '/acount/user',
    name: 'acount',
    meta: { title: '授权管理', icon: 'tree', roles: ['User Management'] },
    children: [
      {
        path: 'user',
        name: 'user',
        component: () => import('@/views/user/index.vue'),
        meta: { title: '用户管理', icon: 'tree', roles: ['User Management'] }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/role/index.vue'),
        meta: { title: '角色管理', icon: 'tree', roles: ['Role Management'] }
      },
      {
        path: 'group',
        name: 'group',
        component: () => import('@/views/group/index.vue'),
        meta: { title: '组群管理', icon: 'tree', roles: ['Group Management'] }
      },
      {
        path: 'permission',
        name: 'permission',
        component: () => import('@/views/permission/index.vue'),
        meta: { title: '权限管理', icon: 'tree', roles: ['Permission Management'] }
      },
      {
        path: 'license_plate_stats',
        name: 'license_plate_stats',
        component: () => import('@/views/LicensePlateStats.vue'),
        meta: { title: '车牌号统计', icon: 'truck', roles: ['Permission Management'] }
      }
    ]
  },
  {
    path: '/option',
    component: Layout,
    redirect: '/option/win_client',
    name: 'option',
    meta: { title: '系统管理', icon: 'tree', roles: ['Update Management'] },
    children: [
      {
        path: 'winclient',
        name: 'winclient',
        component: () => import('@/views/winclient/index.vue'),
        meta: { title: '更新管理', icon: 'tree', roles: ['Update Management'] }
      },
      {
        path: 'posclient',
        name: 'posclient',
        component: () => import('@/views/posclient/index.vue'),
        meta: { title: 'POS软件更新', icon: 'tree', roles: ['Update Management'] }
      },
      {
        path: 'paymode',
        name: 'paymode',
        component: () => import('@/views/paymode/index.vue'),
        meta: { title: '支付方式管理', icon: 'tree', roles: ['Update Management'] }
      },
      {
        path: 'adwxapp',
        name: 'adwxapp',
        component: () => import('@/views/adwxapp/index.vue'),
        meta: { title: '广告管理', icon: 'tree', roles: ['Update Management'] }
      }
      // {
      //   path: 'log',
      //   name: 'Log',
      //   component: () => import('@/views/log/index.vue'),
      //   meta: { title: '日志查询', icon: 'log', roles: ['Audit Log Search'] }
      // }
    ]
  },
  {
    path: '/station_home',
    component: Layout,
    redirect: '/station_home/station',
    name: 'Station Home',
    meta: {
      title: '气站管理',
      icon: 'tree',
      roles: ['Station Self Management', 'Station Employee Self Management']
    },
    children: [
      {
        path: 'station',
        name: 'Station',
        component: () => import('@/views/station/self.vue'),
        meta: { title: '基本信息', icon: 'example', roles: ['Station Self Management'] }
      },
      {
        path: 'station_employee',
        name: 'Station Employee',
        component: () => import('@/views/station/employee/self.vue'),
        meta: { title: '雇员管理', icon: 'people', roles: ['Station Employee Self Management'] }
      },
      {
        path: 'station_dynamic',
        name: 'Station Dyanmic',
        component: () => import('@/views/station/dynamic/self.vue'),
        meta: { title: '气站动态', icon: 'dynamic', roles: ['Station Dynamic Self Search'] }
      }
    ]
  },
  {
    path: '/company_home',
    component: Layout,
    redirect: '/company_home/company',
    name: 'Company Home',
    meta: {
      title: '车队管理',
      icon: 'fleet',
      roles: ['Company Self Management', 'Company Driver Self Management']
    },
    children: [
      {
        path: 'company',
        name: 'Company',
        component: () => import('@/views/company/self.vue'),
        meta: { title: '基本信息', icon: 'example', roles: ['Company Self Management'] }
      },
      {
        path: 'company_driver',
        name: 'Company Driver',
        component: () => import('@/views/driver/company.vue'),
        meta: { title: '司机管理', icon: 'driver', roles: ['Company Driver Self Management'] }
      },
      {
        path: 'card',
        name: 'Company Card Management',
        component: () => import('@/views/card/company.vue'),
        meta: { title: '卡片管理', icon: 'recharge_audit', roles: ['Company Card Management'] }
      },
      {
        path: 'company_dynamic',
        name: 'Company Dynamic',
        component: () => import('@/views/company/dynamic/self.vue'),
        meta: { title: '车队动态', icon: 'dynamic', roles: ['Company Dynamic Self Search'] }
      },
      {
        path: 'driver_dynamic',
        name: 'Driver Dynamic',
        component: () => import('@/views/driver/dynamic/company.vue'),
        meta: { title: '司机动态', icon: 'dynamic', roles: ['Driver Dynamic Self Search'] }
      },
      {
        path: 'card_dynamic',
        name: 'Card Dynamic',
        component: () => import('@/views/card/dynamic/company.vue'),
        meta: { title: '卡片动态', icon: 'dynamic', roles: ['Card Dynamic Self Search'] }
      },
      {
        path: 'company_to_company_transfer',
        name: 'Company To Company Transfer',
        component: () => import('@/views/company/transfer/company.vue'),
        meta: { title: '公公转账', icon: 'transfer', roles: ['Company To Company Transfer'] }
      },
      {
        path: 'company_to_person_transfer',
        name: 'Company To Person Transfer',
        component: () => import('@/views/company/transfer/driver.vue'),
        meta: { title: '公私转账', icon: 'transfer', roles: ['Company To Person Transfer'] }
      },
      {
        path: 'company_to_card_transfer',
        name: 'Company To Card Transfer',
        component: () => import('@/views/company/transfer/card.vue'),
        meta: { title: '卡片转账', icon: 'transfer', roles: ['Company To Card Transfer'] }
      }
    ]
  },
  { path: '*', redirect: '/404', meta: { hidden: true } }
]

export default new Router({
  // mode: 'history',  // Enable this if you need.
  scrollBehavior: (to:any, from:any, savedPosition:any) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: process.env.BASE_URL,
  routes: constantRoutes
})
